import React from 'react';
import { COLORS } from '../../../core/constants/colors';

interface FinalizationStepProps {
  finalizeMessage: string | null;
  finalizing: boolean;
  onBack: () => void;
  onFinalize: () => void;
}

export const FinalizationStep: React.FC<FinalizationStepProps> = ({
  finalizeMessage,
  finalizing,
  onBack,
  onFinalize,
}) => {
  return (
    <div className="flex-1 space-y-6">
      <div className="flex justify-end">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-sm font-semibold hover:underline"
          style={{ color: COLORS.primary.persianIndigo }}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
      </div>
      {finalizeMessage && (
        <div className="rounded-2xl px-4 py-3" style={{ backgroundColor: COLORS.primary.softLime + '20' }}>
          <p className="text-sm font-semibold" style={{ color: COLORS.primary.softLime }}>
            {finalizeMessage}
          </p>
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-xl p-8">
        <h3 className="text-xl font-bold mb-3" style={{ color: COLORS.primary.persianIndigo }}>
          Final review
        </h3>
        <p className="text-sm mb-6" style={{ color: COLORS.primary.persianIndigo, opacity: 0.7 }}>
          Review your completeness summary and finalize your profile to proceed to the dashboard.
        </p>
        <div className="flex gap-4">
          <button
            onClick={onFinalize}
            disabled={finalizing}
            className="flex-1 py-3 rounded-lg font-semibold text-white transition-all hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ backgroundColor: COLORS.extended.azure }}
          >
            {finalizing ? 'Finalizing...' : 'Finalize company profile'}
          </button>
        </div>
      </div>
    </div>
  );
};

